import { SearchWorkflowTasksResponse } from "../../../../service/query";
import { ServiceError } from "../../../../service/Shared";
import { ActionButtons, Column, ErrorBox, Modal, Row } from "../../../../widget";
import { useDeleteTaskModal } from "./useDeleteTaskModal";

interface DeleteTaskModalProps {
  show: boolean;
  closeModal: () => void;
  closePanel: () => void;
  handleRefresh: () => void;
  task?: SearchWorkflowTasksResponse["results"][0];
}

export const DeleteTaskModal = ({
  show,
  closeModal,
  closePanel,
  handleRefresh,
  task,
}: DeleteTaskModalProps): JSX.Element => {
  const { handleDeleteTask, isHandleDeleteTaskLoading, handleCloseModal, errors } = useDeleteTaskModal({
    closeModal,
    closePanel,
    handleRefresh,
    task,
  });

  return (
    <Modal show={show} title="Delete task?" onClose={handleCloseModal}>
      {errors && errors.length > 0 && (
        <Row spacingV="ml" justify="center">
          <Column span={6}>
            <ErrorBox
              title="Please solve the below issues before saving"
              text={errors.map((error: ServiceError) => error.message)}
            />
          </Column>
        </Row>
      )}
      <form onSubmit={(e) => handleDeleteTask(e)}>
        <Row spacingV="ll" justify="center">
          <Column span={10}>
            <p className="body1">
              This action cannot be undone. Once deleted, all associated information will be lost.
            </p>
          </Column>
        </Row>
        <Row justify="center">
          <ActionButtons onCancel={handleCloseModal} submitButtonLabel="Yes" isLoading={isHandleDeleteTaskLoading} />
        </Row>
      </form>
    </Modal>
  );
};
